import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(() => ({
	description: {
		color: "#AFA08B",
		fontFamily: "Cochin, serif",
		fontWeight: 700,
		fontSize: 35,
		lineHeight: 1.2
	}
}));

export default styles;
